import { withFailureReasons } from "@components/CatalogIndex";

/**
 * Toast text for a failed Save as Standard.
 *
 * The synchronize-standard endpoint renders the standard Task's validation
 * errors as `{ title: "Delivery Type Blank", detail: "Delivery type can't be
 * blank" }` - not the jsonapi-resources shape `saveErrorReason` parses (it
 * would surface the title) - so read `detail`, which is the full sentence.
 */
export const saveAsStandardError = (err: unknown): string => {
  const errors = (err as { data?: { errors?: unknown } } | null)?.data?.errors;
  const reasons = Array.isArray(errors)
    ? errors.map((e) => ({
        reason: (e as { detail?: string } | null)?.detail || null,
      }))
    : [];

  return withFailureReasons(
    "Something went wrong saving this service to standards.",
    reasons
  );
};
